import { DownOutlined, UpOutlined } from '@ant-design/icons';
import React, { ReactNode } from 'react';
import styles from '../../Style/LayerOverview.module.scss';

interface MenuSectionProps {
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
  children: ReactNode;
}

const MenuSection: React.FC<MenuSectionProps> = ({
  title,
  isExpanded,
  onToggle,
  children,
}) => {
  return (
    <div className={`${styles.menuBox}`}>
      <div className={styles.wrapperLabel}>
        <div className={styles.menuLabel}>{title}</div>
        {isExpanded ? (
          <UpOutlined onClick={onToggle} className={styles.toggleArrow} />
        ) : (
          <DownOutlined onClick={onToggle} className={styles.toggleArrow} />
        )}
      </div>
      {isExpanded && children}
    </div>
  );
};

export default MenuSection;
